import { FC, useEffect } from 'react';
import IdentityPageLayout from '@/features/identity/components/IdentityPageLayout.tsx';
import ChangePasswordForm from '@/features/identity/components/ChangePasswordForm.tsx';
import { useParams } from 'react-router-dom';
import { useSignOut } from './hooks/useSignOut';

const SetPasswordPage: FC = () => {
    const { token } = useParams<{ token: string }>();
    const signOut = useSignOut();

    useEffect(() => {
        signOut();
    }, []);

    if (!token) {
        return (
            <IdentityPageLayout>
                <div className="text-red-500">
                    {`Token is missing in the URL. Please check the link and try again.`}
                </div>
            </IdentityPageLayout>
        );
    }

    return (
        <IdentityPageLayout>
            <ChangePasswordForm token={token} />
        </IdentityPageLayout>
    );
};

export default SetPasswordPage;
